import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Campos de formulário.
 *
 * A altura maior e o texto de 16px abaixo de `sm` não são estética: o Safari
 * do iPhone dá zoom automático em qualquer campo com fonte menor que 16px
 * assim que ele recebe foco, e o usuário fica com a tela deslocada, tendo de
 * afastar com dois dedos a cada campo preenchido. Acima de `sm`, volta ao
 * tamanho compacto do desktop.
 */
const BASE_CAMPO =
  'border-entrada bg-cartao text-cartao-texto w-full rounded-md border px-3 text-base sm:text-sm ' +
  'placeholder:text-silenciado-texto ' +
  'focus-visible:outline-foco focus-visible:outline-2 focus-visible:outline-offset-2 ' +
  'disabled:cursor-not-allowed disabled:opacity-50';

export function Entrada({ className, type = 'text', ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      className={cn(
        BASE_CAMPO,
        'h-11 py-2 sm:h-10',
        // Estado de erro comunicado por aria-invalid, não só por cor.
        'aria-[invalid=true]:border-destrutivo aria-[invalid=true]:outline-destrutivo',
        className,
      )}
      {...props}
    />
  );
}

export function AreaTexto({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn(
        BASE_CAMPO,
        'min-h-20 py-2',
        'aria-[invalid=true]:border-destrutivo',
        className,
      )}
      {...props}
    />
  );
}

export function Selecao({ className, children, ...props }: React.ComponentProps<'select'>) {
  return (
    <select
      className={cn(BASE_CAMPO, 'h-11 sm:h-10', 'aria-[invalid=true]:border-destrutivo', className)}
      {...props}
    >
      {children}
    </select>
  );
}
